import { Component, OnInit, ViewChild, OnDestroy, AfterContentChecked } from '@angular/core';
import { AppState } from '../../../models/appState';
import { LogicService } from '../../../services/logic.service';
import { AuthenticationService } from 'projects/bimbo/src/app/services/authentication.service';
import { MatTabChangeEvent, MatDialog, MatSelectChange } from '@angular/material';
import { SavingParameters, PeriodTypeEnum, ScheduleDate, Parameter, BonusInfo } from '@akiba/models_bimbo';
import { CancelConfirmDialogComponent } from '../../../dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';
import { InfoDialogComponent } from '../../../dialogs/info-dialog/info-dialog.component';
import { UiService } from '../../../services/ui.service';
import { UploadService } from '../../../services/upload.service';
import { Subscription } from 'rxjs';
import { DataSourceService } from '../../../services/data-source.service';
import * as moment from 'moment';

@Component({
  selector: 'app-permanent-savings-parameters',
  templateUrl: './permanent-savings-parameters.component.html',
  styleUrls: ['./permanent-savings-parameters.component.scss']
})
export class PermanentSavingsParametersComponent implements OnInit, OnDestroy {

  modParameter: Parameter | null = null;
  savingParameters: Array<Parameter> = new Array<Parameter>();
  parameterSubscription: Subscription;
  //////////////////////////////////
  //////////////////////////////////
  dt = moment();
  minuteReset = this.dt.parseZone().utcOffset();
  isEdit = false;
  isNew = false;
  selectedIndex = 0;
  contentLocation: AppState = new AppState();
  loanListParameters: any = {
    active: true,
    idParameter: '',
    title: '',
    loanListDates: []
  };

  //////////////////////////////////
  //////////////////////////////////

  uploadSubscription: Subscription = null;
  parameterChangedSubscription: Subscription = null;

  //////////////////////////////////
  //////////////////////////////////

  tempPeriod: SavingParameters | null = null;

  //////////////////////////////////

  hideActions = false;
  tmpHasDR: boolean | undefined;

  @ViewChild('name', { static: false }) name: any;
  constructor(public logicService: LogicService, public dialog: MatDialog, public ui: UiService, private uploadService: UploadService, private dataService: DataSourceService, public authService: AuthenticationService) {

    if (!this.logicService.dataManager.parameterDataLoader.parameters) {

      this.parameterSubscription = this.logicService.dataManager.parameterDataLoader.changes.subscribe(p => {

        if (p && p.response) {
          this.savingParameters = this.logicService.dataManager.parameterDataLoader.parameters.map(element => new Parameter(element)).filter(element => element.type === 2);
        }

      });

      this.logicService.dataManager.parameterDataLoader.load();

    } else {

      this.savingParameters = this.logicService.dataManager.parameterDataLoader.parameters.map(element => new Parameter(element)).filter(element => element.type === 2);

    }

  }

  ngOnInit() {
    this.modParameter = new Parameter();
    this.contentLocation.savingParametersIndex = 0;

  }

  keyUpMethod(event: string) {
    if (event) {
      this.isNew = true;
    } else {
      this.isNew = false;
      this.contentLocation.savingParametersIndex = 0;
    }
  }

  tabChanged(event: MatTabChangeEvent): void {
    this.selectedIndex = event.index;
  }

  selectedPeriodChange(event: MatSelectChange) {

    if (!event.value) {
      this.isEdit = false;
      this.isNew = false;
      this.tempPeriod = null;
      this.modParameter = new Parameter();
      this.hideActions = false;
      this.contentLocation.savingParametersIndex = 0;
    } else {
      this.isEdit = true;
      this.isNew = false;
      this.modParameter = event.value;
      this.tmpHasDR = this.modParameter.hasDRDistribution;
      this.tempPeriod = event.value;
    }

  }

  cancelPeriodChanges() {

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea descartar los cambios hechos?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });
    dialogConfirmation.afterClosed().subscribe(async result => {
      if (result) {
        this._setOriginalValues();
        this.reset();
      }
    });

  }

  savePeriod() {

    const authUser = this.logicService.dataManager.principalDataLoader.employee ? this.logicService.dataManager.principalDataLoader.employee : this.authService.authEmployee;
    this.modParameter.type = PeriodTypeEnum.permanentSaving;
    this.modParameter.active = true;

    if (this.modParameter.savingParameter.weeklyMin < 1 || this.modParameter.savingParameter.weeklyMin > 1000000) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'La cantidad mínima semanal es inválida.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.modParameter.savingParameter.biWeeklyMin < 1 || this.modParameter.savingParameter.biWeeklyMin > 1000000) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'La cantidad mínima catorcena es inválida.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (!this.modParameter.savingParameter.registrationDates || !this.modParameter.savingParameter.registrationDates.length) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Se debe de ingresar al menos un periodo de inscripción.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (!this.modParameter.savingParameter.withdrawDates || !this.modParameter.savingParameter.withdrawDates.length) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Se debe de ingresar al menos un periodo de retiro.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (!this.modParameter.savingParameter.includedCompanies || !this.modParameter.savingParameter.includedCompanies.length) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Se debe de incluir al menos una compañía.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (!this.modParameter.savingParameter.bonusPercentageForLoan || !this.modParameter.savingParameter.bonusPercentageForLoan.length) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Se debe de incluir al menos un periodo de Aportaciones extraordinarias (Bonos).',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (!this.modParameter.savingParameter.contractTypes || !this.modParameter.savingParameter.contractTypes.length) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Se debe de incluir al menos un tipo de contrato.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (!this.modParameter.title) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'El nombre del ciclo es requerido.',
          close: 'Aceptar'
        }
      });

      return;

    }

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea guardar el ciclo con la información proporcionada?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });

    let subs = dialogConfirmation.afterClosed().subscribe(result => {

      if (result) {
        let createDate = new Date();
        let paramLogs = {
          changeID: '',
          collection: 'parameters',
          approvedUid: authUser.uid,
          approvedBy: {
            firstName: authUser.firstName,
            firstLastName: authUser.firstLastName,
            employeeNumber: authUser.workInformation.employeeNumber,
          },
          createDate: createDate,
          timeStamp: createDate.getTime()
        };
        
        if(this.isNew === true && this.modParameter.parametersID === ''){
          this.modParameter.parametersID = createDate.getTime().toString();

        this.loanListParameters.idParameter = this.modParameter.parametersID;
        this.loanListParameters.title = this.modParameter.title;
        this.dataService.insertLoanListParameters(this.loanListParameters).catch(error => {
          console.log('Error al guardar Loan List');
        });

         }


        this.ui.showSpinner();
        

        if (this.modParameter.savingParameter.fileUploaded.file) {

          this.uploadService.pushUpload(this.modParameter.savingParameter.fileUploaded);
          this.uploadSubscription = this.uploadService.downloadURLSubject.subscribe(downloadURL => {

            const p = this.modParameter;
            p.savingParameter.fileUploaded.file = null; 
            p.savingParameter.fileUploaded.downloadURL = downloadURL;

            if (this.uploadSubscription && !this.uploadSubscription.closed) {
              this.uploadSubscription.unsubscribe();
              this.uploadSubscription = null;
            }

            this.resetDates(p.investmentParameterNonSavers.investmentDates);
            this.resetDates(p.investmentParameterSavers.investmentDates);
            this.resetDates(p.savingParameter.withdrawDates);
            this.resetDates(p.savingParameter.registrationDates);

            if (p.loansParameters && p.loansParameters.length > 0 ){
              for (const loansParameter of p.loansParameters) {
                this.resetDates(loansParameter.loanDates);
              }
    
            }
    
            if (p.savingParameter.bonusPercentageForLoan && p.savingParameter.bonusPercentageForLoan.length > 0 ){
              for (const bonusPercentageForLoan of p.savingParameter.bonusPercentageForLoan) {
                const periodArray : Array<ScheduleDate> = [];
                periodArray.push (bonusPercentageForLoan.period);
                this.resetDates(periodArray);
              }
            }

            const aPeriodObj = p.toAny();
            delete aPeriodObj.loanParameter;
            paramLogs.changeID = aPeriodObj.parametersID;

          this.dataService.saveLogAdministratorActions(paramLogs, 'permanentSavingsParametersFileUploaded');

            this.dataService.saveParameter(aPeriodObj).then(() => {

            
              this.reset();
              this.ui.stopSpinner();
              this.dialog.open(InfoDialogComponent, {
                data: {
                  message: 'La información ha sido actualizada',
                  close: 'Aceptar'
                }
              });

            }).catch(error => {
              this.ui.stopSpinner();
            });

          });

        } else {

          const aPeriodObj = this.modParameter.toAny();

          this.resetDates(aPeriodObj.investmentParameterNonSavers.investmentDates);
          this.resetDates(aPeriodObj.investmentParameterSavers.investmentDates);
          this.resetDates(aPeriodObj.savingParameter.withdrawDates);
          this.resetDates(aPeriodObj.savingParameter.registrationDates);

          if (aPeriodObj.loansParameters && aPeriodObj.loansParameters.length > 0 ){
            for (const loansParameter of aPeriodObj.loansParameters) {
              this.resetDates(loansParameter.loanDates);
            }
  
          }
  
          if (aPeriodObj.savingParameter.bonusPercentageForLoan && aPeriodObj.savingParameter.bonusPercentageForLoan.length > 0 ){
            for (const bonusPercentageForLoan of aPeriodObj.savingParameter.bonusPercentageForLoan) {
              const periodArray : Array<ScheduleDate> = [];
              periodArray.push (bonusPercentageForLoan.period);
              this.resetDates(periodArray);
            }
          }

          delete aPeriodObj.loanParameter;
          paramLogs.changeID = aPeriodObj.parametersID;
          
          this.dataService.saveLogAdministratorActions(paramLogs, 'permanentSavingsParameters');
          this.dataService.saveParameter(aPeriodObj).then(() => {

            this.reset();
            this.ui.stopSpinner();
            this.dialog.open(InfoDialogComponent, {
              data: {
                message: 'La información ha sido actualizada',
                close: 'Aceptar'
              }
            });

          }).catch(error => {
            this.ui.stopSpinner();
          });

        }

      }

      if (subs && !subs.closed) {
        subs.unsubscribe();
        subs = null;
      }

    });

  }

  resetDates(dates: ScheduleDate[]) {
    if (dates.length > 0) {
      
      for (const iterator of dates) {
        let startMoment = moment(iterator.startDate).startOf('day');
        let endMoment = moment(iterator.endDate).startOf('day');
        iterator.startDate = startMoment.add(this.minuteReset, 'minutes').toDate();
        iterator.endDate = endMoment.add(this.minuteReset, 'minutes').toDate();
      }
    }
  }

  reset() {

    this.modParameter = new Parameter();
    this.tempPeriod = null;
    this.contentLocation.savingParametersIndex = 0;
    this.isNew = false;
    this.isEdit = false;
    this.name.reset();
    this.selectedIndex = 0;
    this.loanListParameters = null;

  }

  ngOnDestroy(): void {


    if (this.parameterChangedSubscription && !this.parameterChangedSubscription.closed) {
      this.parameterChangedSubscription.unsubscribe();
      this.parameterChangedSubscription = null;
    }

    if (this.uploadSubscription && !this.uploadSubscription.closed) {
      this.uploadSubscription.unsubscribe();
      this.uploadSubscription = null;
    }

    if (this.parameterSubscription && !this.parameterSubscription.closed) {
      this.parameterSubscription.unsubscribe();
      this.parameterSubscription = null;
    }

  }

  hideActionButtons(hide: boolean) {
    this.hideActions = hide;
  }

  private _setOriginalValues() {
    if (this.tmpHasDR !== undefined) {
      this.modParameter.hasDRDistribution = this.tmpHasDR;
    }
  }

}
